import React from 'react';
import { Image, PictureAsPdf, InsertDriveFile, Close } from '@material-ui/icons';
import './PendingAttachmentsList.css';

const getFileIcon = (mimeType) => {
  if (!mimeType) return <InsertDriveFile className="pending-file-icon default" />;
  if (mimeType.startsWith('image/')) return <Image className="pending-file-icon image" />;
  if (mimeType === 'application/pdf') return <PictureAsPdf className="pending-file-icon pdf" />;
  return <InsertDriveFile className="pending-file-icon default" />;
};

const PendingAttachmentsList = ({ files = [], onRemove }) => {
  if (!files.length) return null;

  return (
    <div className="pending-attachments-list">
      {files.map((file) => (
        <div key={file.id} className="pending-attachment-item">
          <span className="file-icon">
            {getFileIcon(file.type)}
          </span>
          <span className="file-name">{file.name}</span>
          <button
            type="button"
            className="remove-file-btn"
            onClick={() => onRemove(file.id)}
            aria-label="Remove file"
          >
            <Close style={{ fontSize: 14 }} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default PendingAttachmentsList;
